import { reportContext } from "contexts/ReportContext";
import React, { useContext } from "react";
import { Dropdown, Icon, Segment } from "semantic-ui-react";

function ReportFilters() {
	const reportData = useContext(reportContext);
	return (
		<Segment basic style={{ marginTop: "0px", paddingTop: "0px" }}>
			<Icon style={{ marginRight: "20px" }} name="filter" />
			<Dropdown
				selection
				clearable
				placeholder="Sales State"
				header="Filter by sales state"
				selectOnBlur={false}
				options={[
					{
						key: "cash",
						value: "cash",
						text: "Cash",
					},
					{
						key: "credit",
						value: "credit",
						text: "Credit",
					},
				]}
				onChange={(e, b) => reportData.setStateFilter(b.value)}
			/>
			<Dropdown
				style={{ marginLeft: "15px" }}
				selection
				search
				clearable
				placeholder="Products"
				header="Filter by product"
				selectOnBlur={false}
				options={reportData.productList.map((item) => ({
					key: item._id,
					value: item._id,
					text: item.name,
				}))}
				onChange={(e, b) => reportData.setProductFilter(b.value)}
			/>
		</Segment>
	);
}

export default ReportFilters;
